import { useReactiveVar } from '@apollo/client'
import { dictionariesVar, projectVar } from '../apollo/reactive-vars'

type UseIds = {
  getProviderId: (
    versionId: string,
    containerName: string,
    providerName: string,
  ) => string | null
}

export function useIds(): UseIds {
  const { getSystemContainerTitle } = useReactiveVar(dictionariesVar)
  const project = useReactiveVar(projectVar)
  const versions = project?.versions ?? []

  function getProviderId(
    versionId: string,
    containerName: string,
    providerName: string,
  ): string | null {
    if (containerName === '') {
      return null
    }
    const version = versions.find((v) => v.id === versionId)
    if (!version) {
      throw new Error('Version not found when searching providerId')
    }
    const systemContainers = [...version.buildings, ...version.localGrids]
    const container = systemContainers.find(
      (systemContainer) =>
        getSystemContainerTitle(systemContainer) === containerName,
    )
    const provider = container?.providers.find(
      (containerProvider) => containerProvider.name === providerName,
    )
    return provider?.id ?? null
  }

  return {
    getProviderId,
  }
}
